import { useContext } from 'react';
import { AuthContext } from 'contexts/AuthContext';

/**
 * Access auth state. Throws if used outside <AuthProvider> so misuse is
 * caught at development time rather than producing silent undefined reads.
 */
export default function useAuth() {
  const ctx = useContext(AuthContext);
  if (ctx === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}
